(function($) {
  $(function() {

      var $slider = $('.why-slider > .slider'),
          supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;;

    $slider.each(function(){

      var $this = $(this),
          currentSlide = 1;

      imagesLoaded($this, function(){
        var slider = $this.sudoSlider({
          continuous:true,
          responsive:true,
          auto:false,
          autoHeight:true,
          speed:500,
          prevNext:false,
          customLink:'.why-slider .controls > a',
          moveCount: 1,
          slideCount: 1,
          touch: false,
          initCallback: function () {
            slider.getSlide(currentSlide).addClass('active');
          },
          beforeAnimation: function (t) {
            slider.getSlide(currentSlide).removeClass('active');
          },
          afterAnimation: function (t) {
            currentSlide = t;
            slider.getSlide(t).addClass('active');
          }
        });

        $(window).on('resize.sliderPause', function () { slider.stopAnimation() });

        if (supportsTouch) {
            $slider.on('swiperight.slider', function () { slider.goToSlide("prev") });
            $slider.on('swipeleft.slider', function () { slider.goToSlide("next") });
        }

      });
    });

  });
})($JQ);
